import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    height: 'auto',
    fontFamily: 'Noto Sans JP',
    fontStyle: 'normal',
    // overflow: 'auto',
  },
  process: {
    margin: '30px auto 50px auto',

  },
  importantRequest: {
    padding: '20px',
    margin: '0',
  },
  storeTitle: {
    fontFamily: 'Noto Sans JP',
    fontStyle: 'normal',
    fontWeight: 500,
    paddingBottom: '0.313em',
    paddingTop: '0.62em',
    color: '#000',
    fontSize: '1.875em',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '30px',
    },
  },
  importantRequest__buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  buttonCalendar: {
    backgroundColor: '#ffffff',
    border: '1px solid #CD0021',
    padding: '11px 15px',
    minWidth: '322px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: '0.8px',
    color: '#cd0821',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
      letterSpacing: '0.28px',
    },
  },
  buttonDatePicker: {
    position: 'absolute',
    padding: 0,
    margin: 0,
    width: '322px',
    height: '100%',
    color: 'transparent',
    opacity: 0,
    zIndex: 2,
    '& .MuiInputBase-root': {
      height: '100%',
    },
    '& input': {
      width: '0px',
    },
    '& .MuiInputAdornment-positionEnd': {
      marginLeft: '0px',
    },
    '& button': {
      width: '322px',
      padding: '0',
      margin: '0',
      height: '100%',
      maxHeight: '48px',
      '& .MuiIconButton-label': {
        height: '48px',
      },
    },
  },
  calendarLegend: {
    fontSize: '13px',
    color: '#1a1a1a',
    lineHeight: '20px',
    letterSpacing: '0.3px',
    margin: '0 20px 16px',
    padding: '8px 12px',
    backgroundColor: '#EBEBEB',
    borderLeft: '3px solid #C0392B',
  },
  calendarLegend_red: {
    color: '#C0392B',
    fontWeight: 700,
  },
  calendarNavigation: {
    borderCollapse: 'collapse',
    width: '100%',
    margin: 0,
    '& td': {
      border: 'none',
      whiteSpace: 'nowrap',
      padding: '2px 10px',
      [theme.breakpoints.down('sm')]: {
        padding: '2px 0px 2px 0px',
      },
      '& a': {
        color: '#cd0021',
        fontSize: '16px',
        letterSpacing: '0.05em',
        lineHeight: 1.5,
        fontWeight: 500,
        [theme.breakpoints.down('sm')]: {
          fontSize: '14px',
          lineHeight: '21px',
        },
      },
    },
  },
  calendarNavigation_btnLeft: {
    textAlign: 'left',
  },
  calendarNavigation_btnRight: {
    textAlign: 'right',
  },
  wrapperTableCalender: {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '99%',
      height: '1px',
      top: 0,
      left: 0,
      background: '#CCC',
      zIndex: 2,
      [theme.breakpoints.down('sm')]: {
        width: '98.5%',
      },
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '99%',
      height: '1px',
      top: 30,
      left: 0,
      background: '#ccc',
      zIndex: 2,
      [theme.breakpoints.down('sm')]: {
        top: 39,
        width: '98.5%',
      },
    },
  },
  tableCalendar: {
    maxWidth: '980px',
    margin: '0 0 1%',
    fontSize: '16px',
    letterSpacing: '0.05em',
    lineHeight: 1.5,
    fontWeight: 500,
    overflowY: 'auto',
    maxHeight: '735px',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      height: '8px',
      width: '8px',
      background: '#E5E5E5',
      borderRadius: '10px',
      marginTop: '10px',
      marginBottom: '10px',
      [theme.breakpoints.down('sm')]: {
        height: '4px',
        width: '4px',
      },
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '10px',
      height: '8px',
      width: '8px',
      [theme.breakpoints.down('sm')]: {
        height: '4px',
        width: '4px',
      },
    },
    '&::-webkit-scrollbar-track': {
      background: '#E5E5E5',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
      lineHeight: '17px',
      maxHeight: '521px',
    },
    '& table td': {
      cursor: 'pointer',
    },
    '& table': {
      width: '100%',
      textAlign: 'center',
      borderCollapse: 'collapse',
      color: '#666666',
    },
    '& th , & td': {
      height: '29px',
      padding: '2px 10px',
      border: '1px solid #ccc',
      [theme.breakpoints.down('sm')]: {
        height: '30px',
        padding: '2px 2px',
      },
    },
  },
  tableCalendar_day: {
    backgroundColor: '#FEECED',
    position: 'sticky',
    top: '0px',
    borderLeft: '1px solid #ccc',
  },
  tableCalendar_day_saturday: {
    color: '#0000FF',
  },
  tableCalendar_day_sunday: {
    color: '#D0111B',
  },
  tableCalendar_time: {
    backgroundColor: '#FEECED',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      lineHeight: '17px',
    },
  },
  tableCalendar_timeHalf: {
    backgroundColor: '#FEECED',
    textAlign: 'right',
    fontSize: '0.8em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '9px',
      lineHeight: '13px',
    },
  },
  tableCalendar_off: {
    backgroundColor: '#FFF',
    '&:hover': {
      backgroundColor: '#FBEEEE',
      transition: 'all 100ms',
    },
  },
  tableCalendar_on: {
    color: '#D0111B',
    '&:hover': {
      backgroundColor: '#FBEEEE',
      transition: 'all 100ms',
    },
  },
  tableCalendar_disable: {
    background: '#EBE9E9',
  },
  tableCalendar_active: {
    background: '#D0111B !important',
    color: '#FFF !important',
  },
  tableCalendar_hiddenCalender: {
    height: 0,
    overflow: 'hidden',
    transition: 'overflow 600ms',
  },
  borderTopBold: {
    borderTop: '2px solid #ccc',
  },
  disabledCursor: {
    // cursor: 'default',
    color: '#6f7878 !important',
  },
}));

export default useStyles;
